<template>
    <div class="page-container">
        <div class="container-fluid">
            <!-- Navigation Breadcrumb -->
            <div class="page-navigation">
                <div class="breadcrumb-custom">
                    <router-link to="/">
                        <i class="fas fa-home"></i> Home
                    </router-link>
                    <span class="separator">/</span>
                    <router-link :to="{ name: 'announcement' }">Pengumuman</router-link>
                    <span class="separator">/</span>
                    <span>{{ announcement ? announcement.title : '...' }}</span>
                </div>
            </div>

            <div class="row justify-content-center">
                <div class="col-12 col-lg-8">

                    <button class="btn btn-sm btn-outline-secondary mb-3" @click="goBack">
                        <i class="fas fa-arrow-left"></i> Kembali
                    </button>

                    <div v-if="announcement" class="card">
                        <div class="card-body">
                            <h2 class="announcement-detail-title">{{ announcement.title }}</h2>
                            <p class="text-muted mb-1">
                                <i class="far fa-calendar-alt"></i> {{ announcement.start_at }}
                                <span class="ml-3">
                                    <i class="far fa-eye"></i> {{ announcement.read_count }} dibaca
                                </span>
                            </p>
                            <hr />

                            <!-- Kandungan rich (sudah disanitize oleh idarah) -->
                            <div class="announcement-content" v-html="announcement.content"></div>

                            <!-- Fail lampiran -->
                            <div v-if="announcement.files && announcement.files.length" class="mt-4">
                                <h6 class="font-weight-bold">Lampiran</h6>
                                <ul class="list-group">
                                    <li
                                        class="list-group-item d-flex align-items-center"
                                        v-for="file in announcement.files"
                                        :key="file.id"
                                    >
                                        <i
                                            class="mr-2"
                                            :class="file.is_image ? 'fas fa-image text-info' : 'fas fa-file-pdf text-danger'"
                                        ></i>
                                        <span class="flex-grow-1">{{ file.original_name }}</span>
                                        <small class="text-muted mr-3">{{ formatSize(file.file_size) }}</small>
                                        <a
                                            :href="file.file_url"
                                            target="_blank"
                                            rel="noopener"
                                            class="btn btn-sm btn-primary"
                                        >
                                            <i class="fas fa-download"></i> Muat Turun
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <!-- Keadaan kosong / tidak dijumpai -->
                    <div v-else-if="!loading" class="empty-state-sm">
                        <i class="fas fa-exclamation-circle"></i>
                        <p>Pengumuman tidak dijumpai</p>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AnnouncementDetail',
    data() {
        return {
            loading: false,
            announcement: null,
        }
    },
    mounted() {
        this.loadDetail()
    },
    watch: {
        '$route.params.id'() {
            this.loadDetail()
        },
    },
    methods: {
        async loadDetail() {
            this.loading = true
            this.$Progress.start()
            try {
                this.announcement = await this.$store.dispatch(
                    'announcement/fetchDetail',
                    this.$route.params.id
                )
                this.markRead(this.$route.params.id)   // v2: บันทึกอ่านแล้วลง DB (กันเด้ง popup ซ้ำ + นับจำนวนคนอ่าน)
                this.$Progress.finish()
            } catch (error) {
                this.announcement = null
                this.handleApiError(error)
            } finally {
                this.loading = false
            }
        },

        goBack() {
            this.$router.push({ name: 'announcement' })
        },

        // v2: บันทึก "อ่านแล้ว" ลง DB ผ่าน API (แทน localStorage) — กันนับซ้ำฝั่ง server
        // คืน read_count ล่าสุด → อัปเดตตัวเลขบนหน้าโดยไม่ต้องโหลดใหม่; เงียบ error (ไม่กระทบการอ่าน)
        async markRead(id) {
            try {
                const res = await this.$store.dispatch('announcement/markRead', id)
                if (res && this.announcement) {
                    this.announcement.read_count = res.read_count
                }
            } catch (e) {
                // eslint-disable-next-line no-console
                console.log(e)
            }
        },

        formatSize(bytes) {
            if (!bytes) return '-'
            if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(0) + ' KB'
            return (bytes / 1024 / 1024).toFixed(1) + ' MB'
        },

        handleApiError(error) {
            this.$Progress.fail()
            if (error.response && (error.response.status === 401 || error.response.status === 419)) {
                this.$store.dispatch('authentication/cencelAuthen')
            }
            // eslint-disable-next-line no-console
            console.log(error)
        },
    },
}
</script>

<style scoped>
.announcement-detail-title {
    color: #2c3e50;
    font-weight: 700;
}
.announcement-content >>> img {
    max-width: 100%;
    height: auto;
}
</style>
